import useForm from "./form";

const Subscribe = () => {
  const {
    firstNameRef,
    lastNameRef,
    emailRef,
    onValuesChange,
    onSubmit,
    status,
  } = useForm();
  return (
    <div>
      <p className="text-center">
        We would love you to subscribe to updates from Daisho.
      </p>
      <p className="text-center">
        We promise we wont give your email to others. Nor are we going to spam
        you!
      </p>
      <div className="w-full max-w-2xl mx-auto mb-8 mt-2 pt-2">
        <form onSubmit={onSubmit}>
          <div>
            <input
              className="appearance-none block w-full py-3 px-4 leading-tight text-gray-700 bg-gray-200 focus:bg-white border border-gray-200 focus:border-gray-500 rounded focus:outline-none"
              type="email"
              placeholder="Email"
              required
              ref={emailRef}
              onChange={onValuesChange}
            />
          </div>
          <div className="mt-4 grid sm:grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <input
                className="appearance-none block w-full py-3 px-4 leading-tight text-gray-700 bg-gray-200 focus:bg-white border border-gray-200 focus:border-gray-500 rounded focus:outline-none"
                placeholder="First Name"
                required
                ref={firstNameRef}
                onChange={onValuesChange}
              />
            </div>
            <div>
              <input
                className="appearance-none block w-full py-3 px-4 leading-tight text-gray-700 bg-gray-200 focus:bg-white border border-gray-200 focus:border-gray-500 rounded focus:outline-none"
                placeholder="Last Name"
                required
                ref={lastNameRef}
                onChange={onValuesChange}
              />
            </div>
          </div>
          <div className="mt-2 pt-2">
            <button
              className={`inline-block w-full py-4 px-8 leading-none text-white ${
                status.submitted
                  ? "bg-indigo-200"
                  : "bg-indigo-500 hover:bg-indigo-600"
              } rounded shadow`}
              type="submit"
              disabled={status.submitted}
            >
              {status.submitting ? "Submitting..." : "Subscribe"}
            </button>
          </div>
          {status.submitted &&
            !status.submitting &&
            (status.info.error ? (
              <div
                className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 mt-3"
                role="alert"
              >
                <p className="font-bold">Unable to Add your Email!!!</p>
                <p className="text-sm">{status.info.msg}</p>
              </div>
            ) : (
              <div
                className="bg-blue-100 border border-blue-500 text-blue-700 px-4 py-3 mt-3"
                role="alert"
              >
                <p className="font-bold">
                  Thanks for the subscribing to our Updates!
                </p>
              </div>
            ))}
        </form>
      </div>
    </div>
  );
};

export default Subscribe;
